export default [
  {
    key: 'none',
    value: 'No submitter role',
    icon: {
      name: 'minus',
    },
  },
]
